/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Defines a list of payment types supported by the system
 */
export enum EnumPaymentMethod {
    /**
     * No payment method
     */
    NotDefined = 0,
    /**
     * The payment is performed in cash
     */
    Cash = 1,
    /**
     * The payment is performed by card
     */
    Card = 2,
    /**
     * The payment is performed through a cheque
     */
    Cheque = 3,
    /**
     * The payment is performed by a bank transfer
     */
    Transfer = 4,
    /**
     * The payment is performed via bank debit
     */
    Debit = 5,
    /**
     * The payment is performed through paypal
     */
    PayPal = 6,
}
